import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

export function AlertMessage({ message, active, toggle }) {
  const toggleModal = () => toggle(!active);

  return (
    <Modal isOpen={active} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Atenção</ModalHeader>
      <ModalBody>{message}</ModalBody>
    </Modal>
  );
}
